module.exports = {"id":"184089","name":"Mehdi Carcela-González","rating":"77","photo":"./data/images/photos/2/184089.png","club":{"name":"Standard Liège","logo":"./data/images/clubs/StandardLiege.png"},"positions":["MD","MG"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MehdiCarcela-Gonzalez0.json
// module id = 2965
// module chunks = 0